module.exports = __webpack_public_path__ + "static/img/z01.d042a3f4.png";